import React from 'react';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SEO from '../components/SEO';
import TrustBar from '../components/TrustBar';

export default function HomePage() {
  const title = 'Subscription Support & Cancellation Service Online';
  const description = 'Manage subscriptions, request cancellations, resolve billing issues, and contact support agents anytime with fast, secure, and reliable assistance.';
  const url = 'https://lsabill.net/';

  return (
    <div className="page-shell min-h-screen">
      <SEO
        title={title}
        description={description}
        canonicalUrl={url}
        ogTitle={title}
        ogDescription={description}
        ogUrl={url}
        ogImage="https://lsabill.net/logo192.png"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: title,
          url,
          description,
          publisher: {
            '@type': 'Organization',
            name: 'Isabill',
            url,
            logo: 'https://lsabill.net/logo192.png',
          },
        }}
      />
      <Header />
      <main className="pb-6">
        <Hero />
        <TrustBar className="pt-0" />
        <Features className="pt-0" />
      </main>
      <Footer />
    </div>
  );
}
